import type { SvgProps } from '@main/core-ui/src/Icon/constants/enums';
import React from 'react';

export const DesktopComputer: React.FC<SvgProps> = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      // eslint-disable-next-line max-len
      d="M15.359 14.1676H4.63949C3.45572 14.1676 2.49609 13.208 2.49609 12.0242V4.63949C2.49609 3.45572 3.45572 2.49609 4.63949 2.49609H15.3581C15.9267 2.49587 16.4721 2.7216 16.8743 3.12358C17.2764 3.52557 17.5023 4.07088 17.5023 4.63949V12.0234C17.5026 12.592 17.2768 13.1374 16.8749 13.5395C16.4729 13.9417 15.9276 14.1676 15.359 14.1676Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5023 10.8329H2.49609"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6674 14.168L12.0842 17.5027"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33229 14.168L7.91545 17.5027"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.7832 17.5028H13.2142"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
